import { useContext } from 'react';
import "./about_page.css";
import { AppContext } from '../../../contextApi/ContextApi';
import AboutPage_section from './AboutPage_section';

export default function AboutPage({website, isDashboard}) {
    const {accent_color, primary_color} = useContext(AppContext);
    const deployAbout=()=>{
      const about = website?.settings?.about || [];
      return about.map((section, inx)=>{
        return <AboutPage_section key={`aboutPage_section_inx_${inx}`} website={website} section={section}/>
      })
    }
  return (
    <div className='aboutPage' dir='rtl'>
        <h1 style={{margin:"50px auto",color:accent_color, textShadow:`2px 2px 4px ${primary_color}`}} dir='rtl'>קצת עלינו...</h1>
        <div className='aboutPage_sectionsDiv'>{deployAbout()}</div>
    </div>
  )
}
